import { Usuario } from '../types'

export function obtenerRutaPanelPorUsuario(usuario: Usuario | null | undefined): string {
  if (!usuario) return '/login'

  const rolGlobal = usuario.rol_global
  const rolOrganizacion = usuario.rol_organizacion
  const tipoOrganizacion = usuario.tipo_organizacion
  const tieneEmpresa = typeof usuario.id_organizacion === 'number'

  if (rolGlobal === 'superadmin' || rolGlobal === 'admin') {
    return '/admin'
  }

  if (tipoOrganizacion === 'institucion') {
    if (['jefe', 'maestro', 'admin', 'supervisor'].includes(rolOrganizacion || '')) {
      return '/institucion/jefes'
    }
    if (['usuario', 'alumno'].includes(rolOrganizacion || '')) {
      return '/institucion/usuarios'
    }
  }

  if (tipoOrganizacion === 'empresa') {
    if (!tieneEmpresa) {
      return '/dashboard'
    }
    if (['admin', 'moderador', 'supervisor', 'contador'].includes(rolOrganizacion || '')) {
      return '/empresa/gestion'
    }
    return '/empresa'
  }

  return '/dashboard'
}

export function esUsuarioPanelGeneral(usuario: Usuario | null | undefined): boolean {
  if (!usuario) return false
  return (
    usuario.rol_global === 'usuario' &&
    !usuario.tipo_organizacion &&
    typeof usuario.id_organizacion !== 'number'
  )
}
